const PUBLIC_PATHS = new Set([
  '/login',
  '/privacy',
  '/terms',
  '/community-guidelines',
  '/desktop-auth-callback',
]);

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.has(pathname);
